import { CountUp } from './countUp.js';
window.CountUp = CountUp;

const countUpObserver = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    // 如果目标元素出现在视口中
    if (entry.isIntersecting) {
      $(entry.target).addClass(inViewClassName);
      if ($(entry.target).hasClass('countup')) {
        $(document).ready(function() {
          const countUp1 = new CountUp('count_up1', 4000);
          const countUp2 = new CountUp('count_up2', 2637);
          const countUp3 = new CountUp('count_up3', 21);
          const countUp4 = new CountUp('count_up4', 100);
          countUp1.start();
          countUp2.start();
          countUp3.start();
          countUp4.start();
        });
      }
    }
  });
}, {
  root: null, // 使用浏览器视口作为参照
  rootMargin: '0px', // 参照的视口边缘外的区域
  threshold: 0.5 // 目标元素有10%进入视口时触发回调
});

countUpObserver.observe(document.querySelector('.ces-2024-half-image .container .countup'));